import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'

export default class Azuredevopstemplate extends Component {

  render() {
    const course =[
      {
        title: "Introduction to Azure DevOps",
        content: [
          "Overview of Azure DevOps",
          "Understanding Azure DevOps services and features",
          "Navigating the Azure DevOps interface",
          "Creating and managing Azure DevOps projects",
          "Introduction to Azure DevOps CLI"
        ]
      },
      {
        title: "Azure DevOps Boards",
        content: [
          "Creating and managing work items",
          "Customizing work item types, fields, and workflows",
          "Creating and managing backlogs and sprints",
          "Tracking progress with dashboards and reports",
          "Integration with external tools and systems"
        ]
      },
      {
        title: "Azure DevOps Repos",
        content: [
          "Creating and managing code repositories",
          "Branching and merging strategies",
          "Code reviews and pull requests",
          "Managing build artifacts and packages",
          "Integration with external version control systems"
        ]
      },
      {
        title: "Azure DevOps Pipelines",
        content: [
          "Creating and managing pipelines",
          "Continuous Integration (CI) and Continuous Delivery (CD)",
          "Building and deploying applications to various environments",
          "Managing secrets and credentials",
          "Integration with external build and deployment tools"
        ]
      },
      {
        title: "Azure DevOps Test Plans",
        content: [
          "Creating and managing test plans",
          "Test case management and execution",
          "Automated testing with Azure Test Plans",
          "Load testing and performance testing",
          "Integration with external test management tools"
        ]
      },
      {
        title: "Azure DevOps Artifacts",
        content: [
          "Creating and managing package feeds",
          "Publishing and consuming packages",
          "Managing versioning and dependencies",
          "Integration with external package management tools",
          "Artifact security and access controls"
        ]
      },
      {
        title: "Azure DevOps Security",
        content: [
          "Understanding Azure DevOps security model",
          "Configuring security and access controls",
          "Managing users, groups, and permissions",
          "Implementing single sign-on (SSO)",
          "Integration with Azure Active Directory (Azure AD)"
        ]
      },
      {
        title: "Azure DevOps Extensions",
        content: [
          "Overview of Azure DevOps extensions",
          "Finding and installing extensions from the Marketplace",
          "Developing custom extensions with Azure DevOps SDK",
          "Publishing and sharing extensions in the Marketplace",
          "Integration with external development tools"
        ]
      },
      {
        title: "Azure DevOps Migration",
        content: [
          "Planning and executing Azure DevOps migration",
          "Migrating data from external tools to Azure DevOps",
          "Migrating data from Azure DevOps to external tools",
          "Managing and troubleshooting migration issues",
          "Best practices for successful Azure DevOps migration"
        ]
      },
      {
        title: "Azure DevOps Monitoring and Reporting",
        content: [
          "Monitoring Azure DevOps services and resources",
          "Creating and managing alerts and notifications",
          "Collecting and analyzing metrics and logs",
          "Building custom dashboards and reports",
          "Integration with external monitoring and reporting tools"
        ]
      },
        {
        title: "Azure DevOps for Open-Source Projects",
        content: [
        "Azure DevOps for open-source projects overview",
        "Creating and managing public projects in Azure DevOps",
        "Git and GitHub integration",
        "Continuous integration and deployment for open-source projects",
        "Azure DevOps and open-source community"
        ]
        },
        {
        title: "Azure DevOps for Mobile and Web Applications",
        content: [
        "Building and deploying mobile applications with Azure DevOps",
        "Building and deploying web applications with Azure DevOps",
        "Azure DevOps and containerization",
        "Managing mobile and web app environments with Azure DevOps",
        "Azure DevOps for microservices"
        ]
        },
        {
          title: "Advanced Azure DevOps",
          content: [
              "Customizing build and release pipelines with YAML",
              "Automating infrastructure deployment with Azure Resource Manager (ARM) templates",
              "Managing Kubernetes deployments with Azure Kubernetes Service (AKS)",
              "Managing infrastructure as code with Azure Terraform",
              "Deploying and managing serverless applications with Azure Functions",
              "Creating and deploying machine learning models with Azure Machine Learning",
              "Monitoring and troubleshooting applications with Azure Monitor",
              "Implementing continuous delivery for microservices architectures",
              "Implementing compliance and governance in Azure DevOps",
              "Implementing DevOps for mobile applications",
              "Implementing DevOps for SAP applications",
              "Advanced analytics and reporting in Azure DevOps"
          ]
      },
    ]

    const faqData = [
      {
        question: 'What is Azure DevOps Training?',
        answer:
          'Azure DevOps Training is a specialized program designed to equip individuals with the skills and knowledge needed to effectively use Microsoft Azure DevOps services for managing software development projects, from planning to deployment',
      },
      {
        question: 'Why is Azure DevOps Training important?',
        answer:
          'Azure DevOps Training is crucial for professionals seeking to adopt modern software development practices, enabling them to streamline collaboration, automate processes, and deliver high-quality software products efficiently',
      },
      {
        question: 'Who can benefit from Azure DevOps Training?',
        answer:
          'Azure DevOps Training at the best training centre is suitable for developers, IT professionals, project managers, and anyone involved in software development, regardless of their level of expertise',
      },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'A person with Azure DevOps skills can pursue a variety of career opportunities such as DevOps Engineer, Cloud Engineer, Azure Solutions Architect, Azure DevOps Consultant, and Azure DevOps Developer. These roles typically involve using Azure DevOps to manage software development projects and infrastructure in a cloud environment',
      },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume',
      },
    ];
    const EligibilityData=[
      {
        cnt:"Embark on a transformative journey into Azure DevOps at the Best Training Centre. Our Azure DevOps training program welcomes individuals from diverse backgrounds, providing them with the skills and knowledge required to excel in modern software development practices. Whether you're a seasoned developer, a project manager, or an IT professional looking to streamline your development process, our courses cater to learners at every level. With a focus on practical application and hands-on learning, our expert instructors guide you through essential Azure DevOps concepts, including source code management, continuous integration, continuous delivery, and collaboration tools. At the Best Training Centre, we prioritize accessibility and inclusivity, ensuring that all learners have the opportunity to thrive in mastering Azure DevOps with the best training centre. Join us and unlock your potential in Azure DevOps at the best training centre"
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Ahamed Ali Imran",
          date:" March 11 ,2023",
          review:` I Joined this institute to take training Azure Devops, My overall experience is very good, the knowledge given by the trainer was very helpful to me throughout trainig session, Keep it up and most recommended.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Anand",
          date:" March 26 ,2023",
          review:"The Azure DevOps training at learnsoft.org Institute was a game-changer for me. The instructor was a true expert in the field and made the course material easy to understand. The hands-on approach to learning was extremely valuable and I feel much more confident in my ability to implement DevOps practices in my work. Thank you, learnsoft.org Institute!"
      },
  ]
    return (
      <>

          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro={`Azure DevOps  ${this.props.location1} is an in-demand field with a growing demand for professionals with Azure DevOps skills. At learnsoft.org, we offer top-notch Azure DevOps training courses in ${this.props.location} to help individuals enhance their skills and gain a comprehensive understanding of Azure DevOps principles and practices. Our experienced trainers use a hands-on approach, incorporating real-world scenarios and practical exercises to provide a well-rounded education. Whether you're new to Azure DevOps or looking to expand your skillset, learnsoft.org's Azure DevOps ${this.props.location1} is the perfect choice to take your career to the next level. Contact us today to learn more about our courses and start your Azure DevOps journey.`}/>
        */}
         <NewMainsec rating='4.9' students={"699"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro={`Azure DevOps  ${this.props.location1} is an in-demand field with a growing demand for professionals with Azure DevOps skills. At learnsoft.org, we offer top-notch Azure DevOps training courses in ${this.props.location} to help individuals enhance their skills and gain a comprehensive understanding of Azure DevOps principles and practices. Our experienced trainers use a hands-on approach, incorporating real-world scenarios and practical exercises to provide a well-rounded education. Whether you're new to Azure DevOps or looking to expand your skillset, learnsoft.org's Azure DevOps ${this.props.location1} is the perfect choice to take your career to the next level. Contact us today to learn more about our courses and start your Azure DevOps journey.`}/>
          
          <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
            <Overview location={this.props.location} location1={this.props.location1} heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={"AZ-400: Designing and Implementing Microsoft DevOps Solutions is a certification exam offered by Microsoft that tests an individual's knowledge and skills in designing and implementing DevOps practices using Azure DevOps. Candidates for this exam should have experience with Azure DevOps, Azure services, and other Azure tools and technologies. They should also be familiar with Agile software development, continuous integration and continuous delivery (CI/CD), infrastructure as code, configuration management, and containerization."} 
            title={this.props.title} course={"Our Azure DevOps course covers a wide range of topics, including continuous integration and continuous delivery, configuration management, and cloud infrastructure. Our experienced trainers will guide you through hands-on exercises and real-world scenarios to help you understand the concepts and techniques used in Azure DevOps. By the end of the course, you will be able to implement Azure DevOps practices in your own projects."}/>
            </section>
            <Batchtime title={this.props.title} fees="30,999" offer="20,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
          <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>
     <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1}  cou2="AWS DevOps" coupath2="aws-devops" cou3='DevOps' coupath3='devops' cou1='Azure Administration' coupath1='azure-admin' cou='Azure' coupath='azure' cou4='Azure Developer' coupath4='azure-developer'
          cou5='Azure Data Bricks' coupath5='azure-databricks' cou6='Azure Solution Architect' coupath6='azure-solution-architect' cou7='Azure Security' coupath7='azure-security'
          cou9='Terraform' coupath9='terraform' cou8='Azure Data Engineering' coupath8='azure-data-engineering'  cou10='Docker' coupath10='docker' />
      
      </>
    );
  }
}
